import { FC } from "react";
import { Box, Heading, Text } from "@smile2impress/components/relaunch";

import { ContentFromCmsProps } from "./ContentFromCms.types";

export const ContentFromCms: FC<ContentFromCmsProps> = ({ content }) => (
    <Box>
        {JSON.parse(content).blocks.map((block: any, index: number) => {
            switch (block.type) {
                case "header":
                    if (!block.data.text) break;

                    return (
                        <Heading
                            key={`header-${index}`}
                            as={`h${block.data.level}` as any}
                            textStyle="caption"
                            color="text.base"
                            mb={0.7}
                        >
                            {block.data.text}
                        </Heading>
                    );
                case "paragraph":
                    if (!block.data.text) break;

                    return (
                        <Text
                            key={`paragraph-${index}`}
                            textStyle="body"
                            mb={2}
                            _last={{ mb: 0 }}
                        >
                            {block.data.text}
                        </Text>
                    );

                default:
                    return null;
            }
        })}
    </Box>
);
